<div class="modal-body" style="height: 980px; width: 1480px">
	<div class="layout-auto-1-auto">
		<!-- Header -->
		<h5 class="modal-header">
			{{getRessource('CreateTextbaustein')}}
		</h5>
		<!-- Content -->
		<div class="modal-form content layout-auto-1">
				<div>
					<exg-select [ngModel]="getIndexOf(dataModel.tb_oeID)"
					            (ngModelChange)="selectionChange($event)"
					            [caption]="getRessource('oe')"
					            [list]="editor.oeList"
					            listdisplay="oeName" name="oeName">
					</exg-select>
					<exg-select [(ngModel)]="dataModel.tb_enmIdent_Typ"
					            [caption]="enumSvc.getFieldCaption(this.editor.enmTable, this.editor.enmName)"
					            [list]="editor.enmList"
					            listdisplay="enmText" name="type" >
					</exg-select>
					<exg-input [(ngModel)]="dataModel.tbName"
					           [caption]="enumSvc.getFieldCaption('Textbaustein','tbName')"
					           name="tbName"
					           type="text">
					</exg-input>
					<exg-input [(ngModel)]="dataModel.tbTextShort"
					           [caption]="enumSvc.getFieldCaption('Textbaustein','tbTextShort')"
					           name="tbTextShort"
					           type="text">
					</exg-input>
				</div>
				<div class="content">
					<editor *ngIf="MCEinit" class="content app-border-none-tiny"
					        [(ngModel)]="dataModel.tbText"
					        [init]="MCEinit">
					</editor>
				</div>
		</div>

		<!-- Footer -->
		<div class="spawn-modal-actions">
			<button (click)="close()" class="md-btn">
				{{getGlobal('Cancel')}}
			</button>
			<button (click)="create()"
			        [disabled]="!dataModel.tb_oeID"
			        class="md-btn">
				{{getGlobal('Create')}}
			</button>
		</div>
	</div>
</div>
